exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-set[data-v-a8817a96] {\n  display: flex;\n}\n.color-set > .color-item[data-v-a8817a96] {\n  width: 25px;\n  height: 16px;\n  box-sizing: border-box;\n  border: 1px solid var(--color11);\n  border-radius: 3px;\n}\n.color-set > .color-item[data-v-a8817a96]:not(:first-child) {\n  margin-left: 5px;\n}\n", ""]);

// exports
